
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { BarChart } from 'lucide-react';

const AnalyticsTab = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <Card>
        <CardHeader>
          <CardTitle>User Engagement</CardTitle>
          <CardDescription>
            Track daily and weekly active users
          </CardDescription>
        </CardHeader>
        <CardContent className="h-80">
          <div className="flex h-full items-center justify-center">
            <div className="text-center text-muted-foreground">
              <BarChart className="mx-auto h-16 w-16 opacity-30 mb-4" />
              <p>Analytics dashboard coming soon</p>
              <p className="text-sm mt-2">User engagement metrics will appear here</p>
            </div>
          </div>
        </CardContent>
      </Card>
      
      <Card>
        <CardHeader>
          <CardTitle>Program Completion</CardTitle>
          <CardDescription>
            Track program completion rates
          </CardDescription>
        </CardHeader>
        <CardContent className="h-80">
          <div className="flex h-full items-center justify-center">
            <div className="text-center text-muted-foreground">
              <BarChart className="mx-auto h-16 w-16 opacity-30 mb-4" />
              <p>Program tracking coming soon</p>
              <p className="text-sm mt-2">Completion rates will appear here</p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default AnalyticsTab;
